import { IconProps } from '../iconProps';

export const EditIcon = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.1 16.5C1.66 16.5 1.28333 16.3435 0.97 16.0306C0.656667 15.7176 0.5 15.3414 0.5 14.902V3.71598C0.5 3.27653 0.656667 2.90033 0.97 2.58739C1.28333 2.27445 1.66 2.11798 2.1 2.11798H9.24L7.64 3.71598H2.1V14.902H13.3V9.34894L14.9 7.75094V14.902C14.9 15.3414 14.7433 15.7176 14.43 16.0306C14.1167 16.3435 13.74 16.5 13.3 16.5H2.1ZM5.3 11.706V8.31024L12.64 0.979401C12.8 0.8196 12.98 0.69975 13.18 0.61985C13.38 0.53995 13.58 0.5 13.78 0.5C13.9933 0.5 14.1967 0.53995 14.39 0.61985C14.5833 0.69975 14.76 0.8196 14.92 0.979401L16.04 2.11798C16.1867 2.27778 16.3 2.45422 16.38 2.64732C16.46 2.84041 16.5 3.03683 16.5 3.23658C16.5 3.43633 16.4633 3.63275 16.39 3.82584C16.3167 4.01893 16.2 4.19538 16.04 4.35518L8.7 11.706H5.3ZM6.9 10.108H8.02L12.66 5.47378L12.1 4.91448L11.52 4.35518L6.9 8.96941V10.108Z'
        fill={fill}
      />
    </svg>
  );
};
